import useBottomSheet from 'hooks/common/useBottomSheet';
import { Button } from 'components/common';
import { useState, useEffect } from 'react';
import { getFlagUrl } from 'utils/userUtils';

function BJCallCostConfirm() {
  const [BJProfile, setBJProfile] = useState<any>();
  const { getSheet, close } = useBottomSheet();

  const user = getSheet('BJCallCostConfirm').data.user;
  const imageUrl = PhotoManager.getPrimePhotoURL(user, true);

  const handleCall = () => {
    CommonUI.makePrimeMatch(user, false, false, null, 'call(user)');
    close('BJCallCostConfirm');
  };

  useEffect(() => {
    PrimeDataManager.getBJProfile(user.fbUid, (err: any, profile: any) => {
      if (err) {
        return;
      }
      setBJProfile(profile);
    });
  }, [user.fbUid]);

  return (
    <>
      <div className="flex flex-col items-center gap-6">
        <div className="typography-headline-md w-full text-center">LOVE MATCH</div>
        <div className="relative flex flex-col items-center gap-2">
          <img alt="" src={imageUrl} className="h-40 w-40 rounded-xl" />
          <div className="absolute bottom-10 flex items-center justify-center gap-1">
            <img className="h-4 w-4" alt="" src={getFlagUrl(user.country)} />
            <div className="typography-headline-sm">{user.nick}</div>
          </div>
          <div className="flex w-fit items-center justify-center gap-[2px] rounded-full bg-base-bg-strong p-1">
            <img alt="" src={'imgweb/icons/ic_coin.png'} className="aspect-square h-4 w-4 p-[1.333px]" />
            <div className="typography-caption-body">{BJProfile?.cost} / 10sec</div>
          </div>
        </div>

        <div className="mb-4 flex w-full gap-[2px] px-2">
          <Button
            onClick={handleCall}
            className="flex-[5] bg-[#FF8F1A] text-[#FFF] gap-[2px]"
            style={{
              text: brsc.call_icon,
              type: 'solid',
              borderRadius: 'full',
              icon: { name: 'profile/video_call.svg' },
            }}
          />
          <Button
            className="flex-[1] rounded-l-md rounded-r-xl"
            onClick={() => close('BJCallCostConfirm')}
            style={{
              type: 'solid',
              color: 'btn-bg-normal',
              icon: { name: 'profile/close.svg', size: 24 },
            }}
          />
        </div>
      </div>
    </>
  );
}

export default BJCallCostConfirm;
